import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { SidebarItemCollapsedHoverIconComponent } from './icon-overlay/sidebar-item-collapsed-hover-icon.component';
import { SidebarItemCollapsedHoverSubpagesComponent } from './subpages/sidebar-item-collapsed-hover-subpages.component';

@Component({
  selector: 'app-sidebar-item-collapsed-hover',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SidebarItemCollapsedHoverIconComponent,
    SidebarItemCollapsedHoverSubpagesComponent,
  ],
  template: `
    <div class="flex" (mouseleave)="exitItem.emit()">
      <div class="group flex w-min flex-col">
        <app-sidebar-item-collapsed-hover-icon />

        <!-- Exit catcher -->
        <div class="flex h-full w-full" (mouseenter)="exitItem.emit()"></div>
      </div>

      <div class="flex h-min w-54 flex-col">
        <app-sidebar-item-collapsed-hover-subpages />
      </div>
    </div>
  `,
})
export class SidebarItemCollapsedHoverComponent {
  /** OUTPUTS **/
  public readonly exitItem = output<void>();
}
